<template>
  <div class="mar50_t" align="center">
    <img width="60px" height="60px" src="./images/sucess.png"/>
    <div class="mar30_t" style="text-align: center;font-size: 0.30rem;">授权成功</div>
    <div class="mar20_t" style="text-align: center;font-size: 0.20rem; color: gray">请返回电脑端继续操作</div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      shopId: "",
      appId: "",
      platformId: ""
    };
  },
  created() {
    this.platformId = this.$route.query.id;
    this.appId = this.$route.query.appId;
    this.shopId = this.$route.query.shopId;
    if (this.shopId !== "" && this.appId !== "" && this.platformId !== "") {
      this.$store.dispatch("weiXin/weixin/getSaveRelationship", { platformId: this.platformId, appId: this.appId, shopId: this.shopId }).then(() => {
      });
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
